/** Duck-typed: bundling can give `TRPCClientError` another class identity across modules. */
export function isUnauthorizedError(error: unknown): boolean {
	if (typeof error !== 'object' || error == null) return false;
	const data = (error as { data?: { code?: unknown } }).data;
	return typeof data === 'object' && data != null && data.code === 'UNAUTHORIZED';
}

const NGOS_PREFIX = '/ngos';
const POST_LOGIN_DEFAULT = '/dashboard';

/** The router location's own fields; `hash` comes without its `#`. */
export type NgoReturnLocation = { pathname: string; searchStr: string; hash: string };

/**
 * Portal-relative (`/settings?tab=contracts#legal-representative`), without the internal `/ngos` prefix, as
 * `auth.callback.ts` and `select-ngo.tsx` expect. Link format for emails: docs/notes/portals/ngo-area-links.md
 */
export function ngoLoginRedirectPath(location: NgoReturnLocation): string | undefined {
	const { pathname, searchStr, hash } = location;
	const relative = pathname.startsWith(NGOS_PREFIX) ? pathname.slice(NGOS_PREFIX.length) : pathname;
	if (!relative || relative === '/') return undefined;
	return `${relative}${searchStr}${hash ? `#${hash}` : ''}`;
}

/** Open redirect via a crafted link: browsers read `/\evil.com` as `//evil.com`, so both are rejected. */
export function safeNgoRedirect(value: string | null | undefined): string | undefined {
	if (!value) return undefined;
	if (!value.startsWith('/')) return undefined;
	if (value.startsWith('//') || value.startsWith('/\\')) return undefined;
	return value;
}

/** Where a fresh session lands; an href with a scheme would make the router leave the site. */
export function ngoPostLoginHref(redirect: string | null | undefined): string {
	return safeNgoRedirect(redirect) ?? POST_LOGIN_DEFAULT;
}
